<template>
  <svg
    width="54"
    height="54"
    viewBox="0 0 54 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_4770_31398)">
      <rect x="2" width="50" height="50" rx="25" fill="#E63030" />
      <g clip-path="url(#clip0_4770_31398)">
        <path
          d="M37.5 21.8633C36.4063 16.832 32.25 13.1133 27 13.1133C22.8438 13.1133 19.3438 15.5195 17.5938 19.0195C13.2188 19.6758 9.9375 23.1758 9.9375 27.7695C9.9375 32.582 13.875 36.5195 18.4688 36.5195H36.8438C40.7813 36.5195 43.8438 33.2383 43.8438 29.3008C44.0625 25.3633 41 22.082 37.5 21.8633ZM29.8438 26.2383V32.1445H24.1563V26.2383H20L27 19.0195L34 26.2383H29.8438Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_4770_31398"
        x="0"
        y="0"
        width="54"
        height="54"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4770_31398"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4770_31398"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_4770_31398">
        <rect
          width="35"
          height="35"
          fill="white"
          transform="translate(9.5 7.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'IconMenuControlBadge',
} as DefineComponent
</script>
